// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

// This was generated using spacetimedb cli version 1.3.0 (commit ).

/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
import {
  AlgebraicType,
  AlgebraicValue,
  BinaryReader,
  BinaryWriter,
  ConnectionId,
  DbConnectionBuilder,
  DbConnectionImpl,
  Identity,
  ProductType,
  ProductTypeElement,
  SubscriptionBuilderImpl,
  SumType,
  SumTypeVariant,
  TableCache,
  TimeDuration,
  Timestamp,
  deepEqual,
  type CallReducerFlags,
  type DbContext,
  type ErrorContextInterface,
  type Event,
  type EventContextInterface,
  type ReducerEventContextInterface,
  type SubscriptionEventContextInterface,
} from "@clockworklabs/spacetimedb-sdk";
import { Point as __Point } from "./point_type";

export type Character = {
  id: number,
  tabletop: number,
  name: string,
  number: number,
  position: __Point,
  size: number,
  conditions: string[],
  friendly: boolean,
  sprite: string,
  aura: number,
  mountedOn: number,
  initMod: number | undefined,
  initiative: number | undefined,
};

/**
 * A namespace for generated helper functions.
 */
export namespace Character {
  /**
  * A function which returns this type represented as an AlgebraicType.
  * This function is derived from the AlgebraicType used to generate this type.
  */
  export function getTypeScriptAlgebraicType(): AlgebraicType {
    return AlgebraicType.createProductType([
      new ProductTypeElement("id", AlgebraicType.createU32Type()),
      new ProductTypeElement("tabletop", AlgebraicType.createU32Type()),
      new ProductTypeElement("name", AlgebraicType.createStringType()),
      new ProductTypeElement("number", AlgebraicType.createU32Type()),
      new ProductTypeElement("position", __Point.getTypeScriptAlgebraicType()),
      new ProductTypeElement("size", AlgebraicType.createU32Type()),
      new ProductTypeElement("conditions", AlgebraicType.createArrayType(AlgebraicType.createStringType())),
      new ProductTypeElement("friendly", AlgebraicType.createBoolType()),
      new ProductTypeElement("sprite", AlgebraicType.createStringType()),
      new ProductTypeElement("aura", AlgebraicType.createU32Type()),
      new ProductTypeElement("mountedOn", AlgebraicType.createU32Type()),
      new ProductTypeElement("initMod", AlgebraicType.createOptionType(AlgebraicType.createI32Type())),
      new ProductTypeElement("initiative", AlgebraicType.createOptionType(AlgebraicType.createI32Type())),
    ]);
  }

  export function serialize(writer: BinaryWriter, value: Character): void {
    Character.getTypeScriptAlgebraicType().serialize(writer, value);
  }

  export function deserialize(reader: BinaryReader): Character {
    return Character.getTypeScriptAlgebraicType().deserialize(reader);
  }

}


